function productCategorySelectDirective() {
	return {
		scope : {
			category : '=?',
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/productCategorySelectDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'productCategoryService', function($scope, $window, alertService, productCategoryService) {
			$scope.valueWasChangedFromSelector = false;
			$scope.availableCategories = [];

			$scope.searchProductCategories = function(query) {
				var filter = {
				};
				
				if(query){
					filter.name = query;
					filter.value = query;
				}
				
				productCategoryService.searchProductCategories(filter).then(function(response) {
					$scope.availableCategories = response.getData().results;
                }, function(response) {
                	//on error
                });
			};
            
		} ],
		link : function(scope, elem, attr) {
			
		}
	};
};

module.directive('productCategorySelect', [ productCategorySelectDirective ]);
